import axios from 'axios'
import { CurrencyResponse } from 'src/models/organizations.models'
import { getResponseData } from 'src/queries/network.utils'
import { GetOrganizationCurrenciesResponse } from 'src/queries/organizations/currencies/currencies.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

/**
 * Fetches the organization's currency reference list.
 *
 * Unwraps the `{ currencies: [...] }` envelope at the network boundary: every
 * consumer (and the legacy useQueryOrgCurrencies `select`) only ever reads the
 * array, so the envelope never needs to leak past this function.
 *
 * RequestConfig.Default mirrors the Redux thunk's
 * `selectAuthedJsonApiRequestConfig` usage.
 */
export const getOrganizationCurrencies = async (
  orgId: string,
): Promise<CurrencyResponse[]> => {
  const data = await getResponseData(
    axios.get<GetOrganizationCurrenciesResponse>(
      `/organizations/${orgId}/currencies`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

  return data.currencies
}
